import * as AC from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const initialState = {
  logs: [],
  checkins: [],
  customerCheckins: [],
  logsPage: 1,
  logsTotalPages: 1,
  checkinsPage: 1,
  checkinsTotalPages: 1,
  customerCheckinsPage: 1,
  customerCheckinsTotalPages: 1,
  customerCheckinsLoading: false,
  reportsLoading: false,
  logsLoading: false,
  invalidStatusCards: [],
  inactiveStatusCardsLoading: false,
};

const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case AC.GET_LOGS_REQUEST:
      return updateObject(state, {logsLoading: true});
    case AC.GET_INVALID_STATUS_CARDS_REQUEST:
      return updateObject(state, {inactiveStatusCardsLoading: true});
    case AC.GET_CHECKINS_REQUEST:
      return updateObject(state, {reportsLoading: true});
    case AC.GET_LOGS_SUCCEED:
      return updateObject(state, {
        logs: action.payload,
        logsPage: action.page,
        logsTotalPages: action.totalPages,
        logsLoading: false,
      });

    case AC.GET_INVALID_STATUS_CARDS_SUCCEED: 
      return updateObject(state, {
        invalidStatusCards: action.payload, 
        inactiveStatusCardsLoading: false,
      });
    case AC.GET_CHECKINS_SUCCEED:
      return updateObject(state, {
        checkins: action.payload,
        checkinsPage: action.page,
        checkinsTotalPages: action.totalPages,
        reportsLoading: false,
      });

    case AC.GET_CUSTOMERS_CHECKINS_REQUEST:
      return updateObject(state, {customerCheckinsLoading: true});

    case AC.GET_CUSTOMERS_CHECKINS_SUCCEED:
      return updateObject(state, {
        customerCheckins: action.payload,
        customerCheckinsPage: action.page,
        customerCheckinsTotalPages: action.totalPages,
        customerCheckinsLoading: false,
      });

    case AC.GET_CUSTOMERS_CHECKINS_FAILED:
      return updateObject(state, {customerCheckinsLoading: false});

    case AC.GET_INVALID_STATUS_CARDS_FAILED:
      return updateObject(state, {inactiveStatusCardsLoading: false});
    case AC.GET_LOGS_FAILED:
    case AC.GET_CHECKINS_FAILED:
      return updateObject(state, {reportsLoading: false});
    default:
      return state;
  }
};

export default reportsReducer;
